import './Nabbar.css';

function Nabbar({
  title,
  subtitle,
  tabs,
  activeTab,
  onTabChange,
  backendStatus,
  systemMode,
  onReset,
}) {
  return (
    <div className="nabbar-shell">
      <div className="nabbar-orb nabbar-orb-left" aria-hidden="true" />
      <div className="nabbar-orb nabbar-orb-right" aria-hidden="true" />

      <div className="nabbar-copy">
        <span className="nabbar-kicker">{subtitle}</span>
        <h1>{title}</h1>
      </div>

      <div className="nabbar-tabs" role="tablist" aria-label="Workspace pages">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.id}
            className={activeTab === tab.id ? 'nabbar-tab active' : 'nabbar-tab'}
            onClick={() => onTabChange(tab.id)}
          >
            <span className="nabbar-tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="nabbar-controls">
        <span className="nabbar-pill">{backendStatus}</span>
        <span className="nabbar-pill">{systemMode}</span>
        <button className="nabbar-reset" type="button" onClick={onReset}>
          Reset Session
        </button>
      </div>
    </div>
  );
}

export default Nabbar;
